FiltersMdl.controller( 'FiltersCtrl', ['$scope', '$element', 'MobileFiltersSrv', function( $scope, $element, MobileFiltersSrv ) {

	var self = this;


	this.filterOn = true;
	this.current_color = 'yellow';

	/**
	 * Watcher for a service value changes.
	 * This value is being updating by other controllers on runtime according to the user actions on the page
	 * after the states has being loaded.
	 */
	$scope.$watch(function () { return MobileFiltersSrv.filterOn;}, function( filterOn ){
		self.filterOn = filterOn;
	});



}]);
